import React from 'react';
import './MusicPage.css';

// An array holding the list of your sample songs.
const sampleRepertoire = [
  "You're Latest Trick",
  'What a Wonderful World',
  'Fly Me To The Moon',
  'Girl From Ipanema',
  'Volaré',
  'Crazy',
  'The Look Of Love',
  'New York, New York',
  'And many many more...',
];

function MusicPage() {
  const youtubeVideoId1 = 'Q6hqkO00pqo';
  const youtubeVideoId2 = 'lmYeOYNP34U';

  return (
    <div className="music-page-container">

       <div className="music-content">
        <span className="music-eyebrow">Live Performance</span>
        <h2>Sample Repertoire</h2>
        <div className="music-heading-rule"></div>

      {/* --- YouTube Video Embeds --- */}
      <div className="videos-row">
        <div className="video-wrapper">
          <div className="video-container">
            <iframe
              src={`https://www.youtube.com/embed/${youtubeVideoId1}`}
              title="Sample Medley"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
          <p className="video-caption">Sample Medley</p>
        </div>
        <div className="video-wrapper">
          <div className="video-container">
            <iframe
              src={`https://www.youtube.com/embed/${youtubeVideoId2}`}
              title="Raising Funds for Starship @ Catalina Bay Farmers Market"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
          <p className="video-caption">Raising Funds for Starship @ Catalina Bay Farmers Market</p>
        </div>
      </div>

      {/* --- Sample Repertoire List --- */}
      <div className="repertoire-section">
        <span className="repertoire-label">Setlist Highlights</span>
        <ul className="repertoire-list">
          {sampleRepertoire.map((song, index) => (
            <li key={index} className="repertoire-item">
              {song}
            </li>
          ))}
        </ul>
      </div>
      </div>
    </div>
  );
}

export default MusicPage;